import * as React from "react";
import { isNoActionCallbackUri } from "utils/Helpers";
import { emrErrorSvg } from "utils/StaticPaths";
import SessionPanel from "../shared/SessionPanel";

const UriError: React.FC<{
  appName?: string;
  callbackUri?: string;
  callbackButtonText?: string;
  isLoading?: boolean;
  atLeastOneAuthPending?: boolean;
  onSubmit?: () => void;
}> = ({
  appName,
  callbackUri,
  callbackButtonText,
  isLoading,
  onSubmit,
  children,
}) => {
  const button =
    callbackUri && callbackUri.trim() !== ""
      ? {
          text: callbackButtonText ?? `Return to ${appName}`,
          action: onSubmit,
        }
      : undefined;

  return (
    <>
      <SessionPanel
        title={"Invalid link"}
        image={emrErrorSvg}
        primaryButton={isNoActionCallbackUri(callbackUri) ? undefined : button}
        isLoading={isLoading}
        isDisplayCentered
      >
        {children}
      </SessionPanel>
    </>
  );
};

export default UriError;
